module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-58fc5d80d3e2f82541ac5b57bec1909a.webp";